// We're using babel-polyfill to polyfill older browsers with modern ES6 features
// such as Promise and Array / Object functions
import 'babel-polyfill';

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 */

window.Vue = require('vue');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo"

if (Laravel.broadcasting && Laravel.broadcasting.driver == "echo") {
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: Laravel.broadcasting.serverUrl
    });
}

if (Laravel.broadcasting && Laravel.broadcasting.driver == "pusher") {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: Laravel.broadcasting.key,
        cluster: Laravel.broadcasting.options.cluster,
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/app/bootstrap.js